module.exports = __webpack_public_path__ + "img/1_006.46b05426.jpg";